import {Card} from "react-bootstrap";
import React, {useContext} from "react";
import {SoknaderContext} from "./contexts/SoknaderContext";

function PersonaliaCard(props:any){

    const {soknad, setSoknad, poststed, hentInfoFraCrm, errors} = useContext(SoknaderContext);
    const readOnly:boolean = props.readOnly;

    return(
        <Card>
            <Card.Header className={"bg-primary card-header-ext"}>
                Personalia
            </Card.Header>
            <Card.Body>
                <div className="form-group row mb-2">
                    <label className="col-md-2 col-form-label col-form-label-sm">Kjønn</label>
                    <div className="col-md-2">
                        <select
                            className="form-select form-select-sm"
                            disabled={readOnly}
                            value={soknad?.sex}
                            onChange={(e: any) => {
                                setSoknad({...soknad, sex: e.target.value})
                            }}
                        >
                            <option></option>
                            <option value={"Mann"}>Mann</option>
                            <option value={"Kvinne"}>Kvinne</option>
                        </select>
                        {errors?.sex && <span className={"validation-error"}>{errors.sex}</span>}
                    </div>
                    <div className={"col-md-2 text-muted small"}>
                        <button type="button" disabled={readOnly} className="btn btn-link btn-sm" onClick={hentInfoFraCrm}>Hent info fra bruker</button>
                    </div>
                </div>
                <div className="form-group row mb-2">
                    <label className="col-md-2 col-form-label col-form-label-sm">Fornavn</label>
                    <div className="col-md-10">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            readOnly={readOnly}
                            value={soknad?.firstName}
                            onChange={(e: any) => {
                                setSoknad({...soknad, firstName: e.target.value})
                            }}
                        />
                        {errors?.firstName && <span className={"validation-error"}>{errors.firstName}</span>}
                    </div>
                </div>
                <div className="form-group row mb-2">
                    <label className="col-md-2 col-form-label col-form-label-sm">Etternavn</label>
                    <div className="col-md-10">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            readOnly={readOnly}
                            value={soknad?.lastName}
                            onChange={(e: any) => {
                                setSoknad({...soknad, lastName: e.target.value})
                            }}
                        />
                        {errors?.lastName && <span className={"validation-error"}>{errors.lastName}</span>}
                    </div>
                </div>
                <div className="form-group row mb-2">
                    <label className="col-md-2 col-form-label col-form-label-sm">Adresse 1</label>
                    <div className="col-md-10">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            readOnly={readOnly}
                            value={soknad?.address1}
                            onChange={(e: any) => {
                                setSoknad({...soknad, address1: e.target.value})
                            }}
                        />
                        {errors?.address1 && <span className={"validation-error"}>{errors.address1}</span>}
                    </div>
                </div>
                <div className="form-group row mb-2">
                    <label className="col-md-2 col-form-label col-form-label-sm">Adresse 2</label>
                    <div className="col-md-10">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            readOnly={readOnly}
                            value={soknad?.address2}
                            onChange={(e: any) => {
                                setSoknad({...soknad, address2: e.target.value})
                            }}
                        />
                    </div>
                </div>
                <div className="form-group row mb-2">
                    <label className="col-md-2 col-form-label col-form-label-sm">Postnr</label>
                    <div className="col-md-2">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            readOnly={readOnly}
                            value={soknad?.postalCode}
                            onChange={(e: any) => {
                                if (e.target.value.length === 4) {
                                    const pnr = e.target.value;
                                    poststed(pnr).then((x: string) => {

                                        setSoknad({...soknad, postalCode: pnr, city: x})
                                    })
                                } else {
                                    setSoknad({...soknad, postalCode: e.target.value})
                                }
                            }}
                        />
                        {errors?.postalCode && <span className={"validation-error"}>{errors.postalCode}</span>}
                    </div>
                    <label className="col-md-2 col-form-label col-form-label-sm">Poststed</label>
                    <div className="col-md-6">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            readOnly={readOnly}
                            value={soknad?.city}
                            onChange={(e: any) => {
                                setSoknad({...soknad, city: e.target.value})
                            }}
                        />
                        {errors?.city && <span className={"validation-error"}>{errors.city}</span>}
                    </div>
                </div>
                <div className="form-group row mb-2">
                    <label className="col-md-2 col-form-label col-form-label-sm">Epost</label>
                    <div className="col-md-10">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            readOnly={readOnly}
                            value={soknad?.emailAddress}
                            onChange={(e: any) => {
                                setSoknad({...soknad, emailAddress: e.target.value})
                            }}
                        />
                        {errors?.emailAddress && <span className={"validation-error"}>{errors.emailAddress}</span>}
                    </div>
                </div>
                <div className="form-group row mb-2">
                    <label className="col-md-2 col-form-label col-form-label-sm">Mobiltelefon</label>
                    <div className="col-md-3">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            readOnly={readOnly}
                            value={soknad?.mobilePhone}
                            onChange={(e: any) => {
                                setSoknad({...soknad, mobilePhone: e.target.value})
                            }}
                        />
                        {errors?.mobilePhone && <span className={"validation-error"}>{errors.mobilePhone}</span>}
                    </div>
                </div>
            </Card.Body>
        </Card>
    )
}

export default PersonaliaCard